import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { Delete, Get, PostBlob, Post } from '@/api/api-middleware';
import {
  getCompanyID,
  getEmployeeID,
  saveUserPrivilegestoLocalStorage,
} from '@/helpers/Utils';
import { apiPath } from '@/constants/defaultValues';
const initialState = {
  loading: false,
  UserTypePrivileges: [],
  error: '',
};

export const GetPrivilegesByUserTypeID = createAsyncThunk(
  'UsertypePrivilege/GetPrivilegesByUserTypeID',
  async (params, thunkAPI) => {
    try {
      if (!params?.id) {
        return thunkAPI.rejectWithValue('Missing privilege id');
      }
      const response = await Get({
        url: `${apiPath}${'api/Lookup/System/GetAllPrivileges'}/${params.id}`,
      });
      if (response?.data?.data) {
        saveUserPrivilegestoLocalStorage(response?.data?.data);
      }
      console.log(response?.data?.data);
      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const AddUserTypePrivileges = createAsyncThunk(
  'UsertypePrivilege/AddUserTypePrivileges',
  async (params, thunkAPI) => {
    try {
      console.log(params);
      const response = await Post({
        url: `${apiPath}${'api/Lookup/System/AddUserTypePrivilege'}`,
        data: params,
      });
      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const UsertypePrivilegeSlice = createSlice({
  name: 'UsertypePrivilege',
  initialState,
  reducers: {
    clearCurrentItem: (state) => {
      state.UserTypePrivileges = [];
    },
    clearUsertypePrivilege: (state) => {
      state.UserTypePrivileges = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetPrivilegesByUserTypeID.pending, (state) => {
        state.loading = true;
      })
      .addCase(GetPrivilegesByUserTypeID.fulfilled, (state, action) => {
        state.loading = false;
        state.UserTypePrivileges = action.payload;
        state.error = '';
      })
      .addCase(GetPrivilegesByUserTypeID.rejected, (state, action) => {
        state.loading = false;
        state.UserTypePrivileges = [];
        state.error = action.payload ?? 'An error occurred';
      });

    builder
      .addCase(AddUserTypePrivileges.pending, (state) => {
        state.loading = true;
      })
      .addCase(AddUserTypePrivileges.fulfilled, (state, action) => {
        state.loading = false;
        console.log('Success');
        state.error = '';
      })
      .addCase(AddUserTypePrivileges.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload ?? 'An error occurred';
      });
  },
});

export const { clearCurrentItem, clearUsertypePrivilege } =
  UsertypePrivilegeSlice.actions;
export default UsertypePrivilegeSlice.reducer;
